import React from 'react';
import { Helmet } from 'react-helmet-async';
import { IWindowPageTitle } from './interfaces';
import { useTenant } from '@context/TenantProvider';

export const WindowPageTitle: React.FC<IWindowPageTitle> = ({ title }) => {
  const tenant = useTenant();

  return (
    <Helmet>
      <title>
        {title ? `${title} - ` : ''}
        {tenant?.name ?? 'Verenigd'}
      </title>
    </Helmet>
  );
};
